import { ArsListingState, ArslActionSetViewColumnPropertiesId } from "../interface";

/**
 * Updates the listing column properties view.
 *
 * @param state - Current ARS listing state
 * @param action - Set-view-column-properties-id action containing the column id
 * @returns Updated ARS listing state with the new column properties view
 */
export const arsl_setViewColumnPropertiesId = <T>(
  state: ArsListingState<T>,
  action: ArslActionSetViewColumnPropertiesId,
): ArsListingState<T> => ({
  ...state,
  settings: {
    ...state.settings,
    viewColumnPropertiesId: action.colId,
  },
});
